import React from "react";
import { useEffect,useRef } from "react";
import { useLayoutEffect } from "react";
import api from "../../utils/api";
import { useState } from "react";
import { toast } from "react-toastify";
import { getUser,storeSPMAdminColumns,getSPMAdminColumns} from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import Spinner from "../../common/Spinner/Spinner";
import AdminServiceProgressionGrid from "../../components/ServiceRequests/Admin/AdminServiceProgressionGrid";
import CustomerFeedbackContainer from "../EServicePartnerServiceRequests/CustomerFeedbackContainer";
import SPMFilterSection from "../../components/ServiceRequests/Admin/SPMFilterSection";
import ServiceRequestAssignmetSummaryModal from "../../components/ServiceRequests/Admin/ServiceRequestAssignmetSummaryModal";
import FacilitatorReassignmentModal from "../../components/ServiceRequests/Admin/FacilitatorReassignmentModal";

export default function AdminServiceProgressionViewContainer(props)
{
	const FileInputref = React.useRef();
    
    let AllColumns=[
        {
			checked: true,
			label: "Service Name",
			id: "Service Name",
            code: "ServiceName",
		},
        {
			checked: true,
			label: "Package Details",
			id: "Package Details",
            code: "PackageDetails",
		},
        {
			checked: true,
			label: "Customer Details",
			id: "Customer Details",
            code: "CustomerDetails",
		},
        {
			checked: true,
			label: "Facilitator",
			id: "Facilitator",
            code: "Facilitator",
		},
        {
			checked: true,
			label: "Ex Service Partner",
			id: "Ex Service Partner",
            code: "ExServicePartner",
		},
        {
			checked: true,
			label: "Current Status",
			id: "Current Status",
            code: "CurrentStatus",
		},
        {
			checked: true,
			label: "Progression Date",
			id: "Progression Date",
            code: "ProgressionDate",
		},
		{
			checked: true,
			label: "Delivered/Canceled Date",
			id: "Delivered/Canceled Date",
            code: "DeliveredCanceledDate",
		}
	];

    let SearchByOptions=[
		{
			checked: false,
			label: "Facilitator",
			id: "Facilitator",
            code: "Facilitator",
		},
        {
			checked: false,
			label: "Service Instance ID",
			id: "Service Instance ID",
            code: "ServiceInstanceID",
		},
        {
			checked: false,
			label: "Package/Program Instance ID",
			id: "Package/Program Instance ID",
            code: "PackageProgramInstanceID",
		},
        {
			checked: false,
			label: "Customer Email ID",
			id: "Customer Email ID",
            code: "CustomerEmailID",
		},
        
        {
			checked: false,
			label: "Phone Number",
			id: "Phone Number",
            code: "PhoneNumber",
		}
	];

    if(getSPMAdminColumns()==undefined)
    {
        storeSPMAdminColumns(AllColumns);
    }
    else
    {
        AllColumns=getSPMAdminColumns();
    }

    const [ColumnDropdownList, setColumnDropdownList] = useState(AllColumns);
    const [isColumnDropdownOpen, setisColumnDropdownOpen] = useState(false);
    const toggleColumnVisibility=()=>{
        setisColumnDropdownOpen(!isColumnDropdownOpen);
    }

    //Table Grid States
    const [pages, setPages] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setcurrentPage] = useState(0);
    const [tableInstance, setTableInstance] = useState(null);
    const [count, setCount ] = useState(0);
    const [pageSizeOptions,setpageSizeOptions] = useState([
        {
            value: "10",
            label: "10 Rows",
        },
        {
            value: "20",
            label: "20 Rows",
        },
        {
            value: "30",
            label: "30 Rows",
        },
        {
            value: "50",
            label: "50 Rows",
        },
        {
            value: "75",
            label: "75 Rows",
        },
        {
            value: "100",
            label: "100 Rows",
        },
    ]);
    const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
        value: "10",
        label: "10",
    });
    //Table Grid States End

    const [isLoading, setIsLoading] = useState(false);
	const [serviceRequests, setServiceRequests] = useState([]);
	const [selectedServiceRequests, setSelectedServiceRequests] = useState([]);

	const [serviceNameList, setServiceNameList] = useState([]);
	const [selectedServiceNameList, setSelectedServiceNameList] = useState([]);

    /**
	 * For Selectiing Facilitators
	 */
	const [facilitatorList, setFacilitatorList] = useState([]);
	const [selectedFacilitator, setSelectedFacilitator] = useState(null);

	const [showUnassignedServiceRequests,toggleUnassignedServiceRequests,] = useState(false);

    const [showFollowupInPast, toggleFollowupInPast] = useState(false);
	const [showToBeFolledUpToday, toggleToBeFolledUpToday] = useState(false);
	const [showFailedPayments, toggleFailedPayments] = useState(false);

	const [clearCount, setClearCount] = useState(0);
	const [searchTerm, setSearchTerm] = useState("");
	const [searchFilter, setSearchFilter] = useState(null);
	const [filterError, setFilterError] = useState(false);

    const [SearchByDropdownList, setSearchByDropdownList] = useState(SearchByOptions);
    const [isSearchByDropdownOpen, setisSearchByDropdownOpen] = useState(false);
    const toggleSearchByVisibility=()=>{
        setisSearchByDropdownOpen(!isSearchByDropdownOpen);
    }


    const [serviceRequestStatusList, setServiceRequestStatusList] = useState([]);
	const [selectedServiceRequestStatusList,setSelectedServiceRequestStatusList,] = useState([]);
	const [selectedServiceRequestsHasFacilitator,setSelectedServiceRequestsHasFacilitator,] = useState(false);
	const isSearchClicked = useRef(false);

    const [SPMStatusList, setSPMStatusList] = useState([
		{
			checked: false,
			label: "Ready for Progression",
			id: "Ready for Progression",
			code: "Ready for Progression",
		},
		{
			checked: false,
			label: "Payment Confirmed By Partner",
			id: "Payment Confirmed By Partner",
			code: "Payment Confirmed By Partner",
		},
		{
			checked: false,
			label: "Awaiting For Information/Documents",
			id: "Awaiting For Information/Documents",
			code: "Awaiting For Information/Documents",
		},	
		{
			checked: false,
			label: "Service Delivery Started",
			id: "Service Delivery Started",
			code: "Service Delivery Started",
		},
		{
			checked: false,
			label: "Service Deliverables Ready",
			id: "Service Deliverables Ready",
			code: "Service Deliverables Ready",
		},
		{
			checked: false,
			label: "Full Payment Requested",
			id: "Full Payment Requested",
			code: "Full Payment Requested",
		},
		{
			checked: false,
			label: "Full Payment Received",
			id: "Full Payment Received",
			code: "Full Payment Received",
		},
		{
			checked: false,
			label: "Delivered",
			id: "Delivered",
			code: "Delivered",
		},
		{
			checked: false,
			label: "Cancelled",
			id: "Cancelled",
			code: "Cancelled",
		},
	]);
	const [selectedSPMStatus, setSelectedSPMStatus] = useState([]);

	const [paymentStatusList, setPaymentStatusList] = useState([
		{ checked: false, label: "Credit", id: "Credit", code: "Credit" },
		{ checked: false, label: "Failed", id: "Failed", code: "Failed" },
	]);
	const [selectedPaymentStatus, setSelectedPaymentStatus] = useState([]);

	const [currentActiveTab, setCurrentActiveTab] = useState("Service Requests");
	const [unReadFeedbackCount, setunReadFeedbackCount] = useState(0);

	const [numberOfServices, setNumberOfServices] = useState(0);
	const [bulkAssignServiceRequest, setBulkAssignServiceRequest] = useState(
		[]
	);

	/*Package Filter states*/
	const [packageNameListForFilter, setPackageNameListForFilter] = useState([]);
	const [selectedPackageNameListForFilter, setSelectedPackageNameListForFilter] = useState([]);
    
    //Filter states
	const [selectedServiceStatusListForFilter, setSelectedServiceStatusListForFilter] = useState([]);
	const [serviceStatusNameListForFilter, setServiceStatusNameListForFilter] = useState(
        [
            {
                label: "Ready for Progression",
                id: "Ready for Progression",
                value: "Ready for Progression",
            },
            {
                label: "Payment Confirmed By Partner",
                id: "Payment Confirmed By Partner",
                value: "Payment Confirmed By Partner",
            },
            {
                label: "Awaiting For Information/Documents",
                id: "Awaiting For Information/Documents",
                value: "Awaiting For Information/Documents",
            },	
            {
                label: "Service Delivery Started",
                id: "Service Delivery Started",
                value: "Service Delivery Started",
            },
            {
                label: "Service Deliverables Ready",
                id: "Service Deliverables Ready",
                value: "Service Deliverables Ready",
            },
            {
                label: "Full Payment Requested",
                id: "Full Payment Requested",
                value: "Full Payment Requested",
            },
            {
                label: "Full Payment Received",
                id: "Full Payment Received",
                value: "Full Payment Received",
            },
            {
                label: "Delivered",
                id: "Delivered",
                value: "Delivered",
            },
            {
                label: "Cancelled",
                id: "Cancelled",
                value: "Cancelled",
            },
        ]
    );

	const [servicesThroughPackageOptions,setservicesThroughPackageOptions,] = useState([
		{
			value: "all",
			label: "All",
		},
		{
			value: "yes",
			label: "Yes",
		},
		{
			value: "no",
			label: "No",
		},
	]);
	const [selectedServicesThroughPackageOption,setSelectedServicesThroughPackageOption,] = useState({
		value: "all",
		label: "All",
	});
	/*Package Filter States end*/

	/**
	 * pagination states
	 */
	const history = useHistory();
    const [restoreToFirstPage, setRestoreToFirstPage] = useState(undefined);

	const [showConfirmHandholderAssignmentModal,setShowConfirmHandholderAssignmentModal] = useState(false);
	const toggleConfirmHandholderAssignmentModal = () => {
		if (selectedServiceRequests.length == 0) {
			toast("Please select service requests.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		setShowConfirmHandholderAssignmentModal(
			!showConfirmHandholderAssignmentModal
		);
	};

    const ColumnDropdownRef = useRef();
	const SearchDropdownRef = useRef();
	useEffect(() => {
		const interval = setInterval(() => 
		{
			if (isColumnDropdownOpen || isSearchByDropdownOpen) 
			{
			  document.addEventListener("click", close);
			} 
			else 
			{
			  document.removeEventListener("click", close);
			}

		}, 0);
		return () => {
			clearInterval(interval)
			document.removeEventListener("click", close);
		};
	});

	const close = (e) => {
		if (isColumnDropdownOpen) 
		{
			if (ColumnDropdownRef.current && ColumnDropdownRef.current.contains(e.target)) 
			{
				return;
			}
			toggleColumnVisibility()
		}
		else if(isSearchByDropdownOpen)
		{
			if (SearchDropdownRef.current && SearchDropdownRef.current.contains(e.target)) 
			{
				return;
			}
			toggleSearchByVisibility();
		}		
	};

	const [AssignFacilitatorFile,setAssignFacilitatorFile] = useState();
	const [isAssignFacilitatorUploadOpen, setisAssignFacilitatorUploadOpen] = useState(false);
	const handleAssignFacilitatorUploadClick = () => 
	{
		setisAssignFacilitatorUploadOpen(!isAssignFacilitatorUploadOpen);
	};

	const onAssignFacilitatorUpload = (e) => {
		console.log("files", e.target.files);
		setAssignFacilitatorFile(e.target.files[0]);
	};

    useEffect(() => {
		if (selectedServiceRequests.length > 0)
			selectedServiceRequests.map((x) => {
				if (x.refFacilitator.length !== 0) {
					setSelectedServiceRequestsHasFacilitator(true);
				}
			});
	}, [selectedServiceRequests]);

	useEffect(() => {
		let temp = [];
		selectedServiceRequests.map((e) => {
			if (temp.includes(e.nUserId) === false) {
				temp.push(e.nUserId);
			}
		});
		if (temp.length) {
			api.assignFacilitator({ user_ids: temp, get_request: true }).then(
				(d) => {
					setBulkAssignServiceRequest(d.data);

					let numServices = 0;
					Object.entries(d.data).map(([key, value]) => {
						if (typeof value === "object") {
							numServices += value.length;
							value.map((x) => {
								if (x.refHH !== null) {
									// setSelectedServiceRequestsHasHandholder(true);
								}
							});
						}
					});
					setNumberOfServices(numServices);
				}
			);
		} else {
			// setSelectedServiceRequestsHasHandholder(false);
			setBulkAssignServiceRequest([]);
			setNumberOfServices(0);
		}
	}, [selectedServiceRequests]);

    useEffect(() => {
		/**
		 * fetch master list of all handholders in the system
		 */
		if (!getUser()) {
			history.push("/login");
		}
		api.getAllFacilitators().then(({ data }) => {
			const f = Object.keys(data).map((e) => ({ value: e, label: e }));
			setFacilitatorList(f);
		});

		api.getAllPackageCatalogues().then(({ data }) => 
		{
			const packageNamesForFilter = Object.keys(data).map((idx) => {
				return {
					label: data[idx].sPackageOfferTitle,
					id: data[idx].id,
					value: data[idx].id,
				};
			});
			setPackageNameListForFilter(packageNamesForFilter);
		});

	}, []);

    useEffect(() => {
        getAllServiceRequests(tableInstance, true);
        setSelectedServiceRequests([]);        
	}, [selectedPageSizeOption]);

	useEffect(() => {
		if(clearCount>0)
		{
			getAllServiceRequests(tableInstance);
		}		
	}, [clearCount]);

    const fetchServiceRequests = (instance, flag) => {
		// setNavigationClicked(flag);
		getAllServiceRequests(instance, flag);
	};

	const uploadAssignFacilitatorFile = () => {
		if (!AssignFacilitatorFile) 
        {
            toast("Please select file.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }
		var formData = new FormData();

		formData.append(
			"assign_facilitator_data",
			AssignFacilitatorFile,
			AssignFacilitatorFile.name
		);
		setIsLoading(true);
		const data = api
		.uploadAssignFacilitatorData(formData)
		.then(({ data }) => {
			setIsLoading(false);
			FileInputref.current.value = "";
			setAssignFacilitatorFile(null);
			if(data.message)
			{
				toast(data.message, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			}
			else
			{
				toast("File uploaded successful", {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			}
			
		})
		.catch((error) => {
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			setIsLoading(false);
		});
	};

    const getAllServiceRequests = async (instance, flag = false) => {
		if (!instance) return;
		if (!tableInstance) setTableInstance(instance);
		try {

            const { page } = instance.state ?? { page: 0 };
            let icurrentPage=page;
            if (!flag &&isNaN(icurrentPage)) return;
            const pageSize =selectedPageSizeOption.value;

            if(flag || isNaN(icurrentPage))
            {
                icurrentPage=0;
            }else if(isSearchClicked.current){
                icurrentPage=0;
			}

            let filterParameters = {
                page:icurrentPage+1,
                page_size:pageSize,
				pagination:true
            };

            if(currentPage!=icurrentPage)
            {
                setSelectedServiceRequests([]);
            }

			let packageListtemp = [];
			selectedPackageNameListForFilter.map((e) => {
				if(e.value!="*")
				{
					packageListtemp.push(e.value);
				}
			});
			const PackageList=packageListtemp;

			let servicestatusListtemp2 = [];
			selectedServiceStatusListForFilter.map((e) => {
				if(e.value!="*")
				{
					servicestatusListtemp2.push(e.value);
				}
			});
			const serviceStatusList=servicestatusListtemp2;

			if(showUnassignedServiceRequests)
			{
				filterParameters.unassigned_facilitator = showUnassignedServiceRequests;
			}

			if (serviceStatusList.length)
			{
				filterParameters.statusList = serviceStatusList;
			}

			if (PackageList.length) 
			{
				filterParameters.nPackageCatalogueIds = PackageList;
			}

			SearchByDropdownList.map((x) => {
				if (x.checked && searchTerm)
				{
					if(isSearchClicked.current){
						filterParameters.page = 1;
					}
					if(x.code==="Facilitator")
					{
						filterParameters.F_email= searchTerm ;
					}
					else if(x.code==="ServiceInstanceID")
					{
						filterParameters.nResourceInstanceID=searchTerm ;
					}
					else if(x.code==="PackageProgramInstanceID")
					{
						filterParameters.nPackageInstanceId=searchTerm;
					}
					else if(x.code==="CustomerEmailID")
					{
						filterParameters.C_email=searchTerm;
					}
					else if(x.code==="PhoneNumber")
					{
						filterParameters.C_phone=searchTerm ;
					}
				}
			});

			
			setIsLoading(true);

            const { tempServices } = api.getServicesSPM(filterParameters).then(({ data }) => {
                setIsLoading(false);
                if(data)
                {
                    getUnreadFeedbackCount();

                    let { results, count } = data;
                    setcurrentPage(icurrentPage);
                    const totalPages = (count - 1) / pageSize + 1;                    
                    setCount(count);
                    setPages(Math.floor(totalPages));
                    setPageSize(pageSize);
					isSearchClicked.current = false;	

                    results = results.map((e) => {
						console.log(e);
                        if (e["customer_meta"]["email"])
                            e["sEmailAddress"] = e["customer_meta"]["email"];
                        else e["sEmailAddress"] = e['sEmailAddress'] || "";
                        if (e["customer_meta"]["mobile_number"])
                            e["sContactNumber"] = e["customer_meta"]["mobile_number"];
                        else e["sContactNumber"] = e['sContactNumber'] || "";
                        if (e["refCurrentState"]["sServiceState"])
                            e["refSRState"] = e["refCurrentState"]["sServiceState"];
                        else e["refSRState"] = "";
                        if (e["refFacilitator"])
                            e["refFacilitator"] = e["refFacilitator"]["email"];
                        else e["refFacilitator"] = "";
                        return e;
                    });			
                    setServiceRequests(results);
                }
                else
                {
                    toast("", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            }).catch((error) =>
            {
                setIsLoading(false);
                if(error.response.data.detail)
                {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
                else if(error.response.data.message)
                {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
                else{
                    toast("Internal server error", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }                
            });
			
		}
        catch (error) 
        {
			console.error(error);
		}
	};

	const handleFacilitatorAssigned = () => {
		if (!selectedFacilitator) {
			toast("Please select a facilitator.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (selectedServiceRequests.length === 0) return;
		const serviceRequestsUserIDs = selectedServiceRequests.map(
			(sr) => sr.nUserId
		);
		const facilitator = selectedFacilitator.value;
		const payload = {
			Facilitator: facilitator,
			user_ids: serviceRequestsUserIDs,
		};
		setIsLoading(true);
		api.assignFacilitator(payload)
			.then((response) => {
				setSelectedFacilitator(null);
				setSelectedServiceRequests([]);
				getAllServiceRequests(tableInstance,true);
				if (response.status == 207) {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.INFO,
					});
				} else {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
			})
			.catch((error) => {
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
		setIsLoading(false);
	};

	const handleFacilitatorUnAssigned = () => {
		if (selectedServiceRequests.length === 0) return;
		const serviceRequests = selectedServiceRequests.map(
			(sr) => sr.nResourceInstanceId
		);
		const payload = {
			Facilitator: null,
			nResourceInstanceIds: serviceRequests,
		};
		setIsLoading(true);
		api.assignFacilitator(payload)
			.then((response) => {
				setSelectedFacilitator(null);
				setSelectedServiceRequests([]);
				getAllServiceRequests(tableInstance,true);
				if (response.status == 207) {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.INFO,
					});
				} else {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
			})
			.catch((error) => {
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
		setIsLoading(false);
	};

    const handleSearchInputChange = ({ target }) => {
		const { value } = target;
		setSearchTerm(value);
		if (searchFilter === null) {
			setFilterError(true);
		}
	};

	const handleSearchClick = async () => {
		/*if (searchTerm.length > 0 && searchFilter) {
			const { value } = searchFilter;
			const { data } = await api.searchServiceRequestsSPM({
				[value]: searchTerm,
			});

			let { results, count } = data;
			const totalPages = (count - 1) / pageSize + 1;

			results = results.map((e) => {
				if (e["customer_meta"]["email"])
					e["sEmailAddress"] = e["customer_meta"]["email"];
				else e["sEmailAddress"] = "";
				if (e["customer_meta"]["mobile_number"])
					e["sContactNumber"] = e["customer_meta"]["mobile_number"];
				else e["sContactNumber"] = "";
				if (e["refCurrentState"]["sServiceState"])
					e["refSRState"] = e["refCurrentState"]["sServiceState"];
				else e["refSRState"] = "";
				if (e["refFacilitator"])
					e["refFacilitator"] = e["refFacilitator"]["email"];
				else e["refFacilitator"] = "";
				return e;
			});
			setServiceRequests(results);

			setPages(Math.floor(totalPages));
		}
		if (searchTerm.length === 0) {
			getAllServiceRequests(tableInstance);
		}*/
		isSearchClicked.current = true
		getAllServiceRequests(tableInstance);
	};

	const handleClearFilterSearch = () => {
        setSelectedServiceStatusListForFilter([]);
		toggleUnassignedServiceRequests(false);
        setSelectedPackageNameListForFilter([]);
		setSearchTerm("");
		setSearchFilter(null);
		let tempserach = SearchByDropdownList.map((x) => {
            x.checked = false;
            return x;
        });
        setSearchByDropdownList(tempserach);
		isSearchClicked.current = true
		setClearCount(clearCount+1);
		//getAllServiceRequests(tableInstance);
	};

	const toggleAll = () => {
		let temp = selectedServiceNameList;
		if (selectedServiceNameList.length != serviceNameList.length) {
			let tempSR = serviceNameList.map((e) => {
				if (!temp.includes(e.code)) {
					temp = temp.concat(e.code);
					e.checked = true;
				}
				return e;
			});
			setSelectedServiceNameList(temp);
			setServiceNameList(tempSR);
			getAllServiceRequests(tableInstance);
		} else {
			let tempSR = serviceNameList.map((e) => {
				e.checked = false;

				return e;
			});
			setSelectedServiceNameList([]);
			setServiceNameList(tempSR);
			getAllServiceRequests(tableInstance);
		}
	};

	const toggleSelection = (e) => {
		let temp = selectedServiceNameList;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSR = serviceNameList.map((x) => {
				if (x.code === e) {
					x.checked = true;
				}
				return x;
			});
			setServiceNameList(tempSR);
			setSelectedServiceNameList(temp);
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSR = serviceNameList.map((x) => {
				if (x.code === e) {
					x.checked = false;
				}
				return x;
			});
			setServiceNameList(tempSR);
			setSelectedServiceNameList(temp);
			getAllServiceRequests(tableInstance);
		}
	};

	const toggleStatusSelection = (e) => {
		let temp = selectedServiceRequestStatusList;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSrStatus = serviceRequestStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setServiceRequestStatusList(tempSrStatus);
			setSelectedServiceRequestStatusList(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSrStatus = serviceRequestStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setServiceRequestStatusList(tempSrStatus);
			setSelectedServiceRequestStatusList(temp);
			getAllServiceRequests(tableInstance);
		}
	};

	const toggleSPMStatus = (e) => {
		let temp = selectedSPMStatus;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSPMStatus = SPMStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setSPMStatusList(tempSPMStatus);
			setSelectedSPMStatus(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSPMStatus = SPMStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setSPMStatusList(tempSPMStatus);
			setSelectedSPMStatus(temp);
			getAllServiceRequests(tableInstance);
		}
	};

	const togglePaymentStatus = (e) => {
		let temp = selectedPaymentStatus;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempPaymentStatus = paymentStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setPaymentStatusList(tempPaymentStatus);
			setSelectedPaymentStatus(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempPaymentStatus = paymentStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setPaymentStatusList(tempPaymentStatus);
			setSelectedPaymentStatus(temp);
			getAllServiceRequests(tableInstance);
		}
	};
  

    /*Callbacks for Package filter */
	const toggleAllForPackageFilter = () => 
	{
		let temp =[];
		
		if (selectedPackageNameListForFilter.length != packageNameListForFilter.length && selectedPackageNameListForFilter.length!=(packageNameListForFilter.length+1)) 
		{
			if(selectedPackageNameListForFilter.includes({label: "All", value: "*"}))
			{
				temp = selectedPackageNameListForFilter;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = packageNameListForFilter.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedPackageNameListForFilter(temp);
			setPackageNameListForFilter(tempSR);
			getAllServiceRequests(tableInstance);
		} 
		else
		{
			setSelectedPackageNameListForFilter([]);
			getAllServiceRequests(tableInstance);
		}
	};

	const toggleSelectionForPackageFilter = (e) => {
		setSelectedPackageNameListForFilter(e);
	};
	/* Callbacks for Package filter */

    const toggleAllForServiceStatusFilter = () => 
	{
		let temp =[];
		
		if (selectedServiceStatusListForFilter.length != serviceStatusNameListForFilter.length && selectedServiceStatusListForFilter.length!=(serviceStatusNameListForFilter.length+1)) 
		{
			if(selectedServiceStatusListForFilter.includes({label: "All", value: "*"}))
			{
				temp = selectedServiceStatusListForFilter;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = serviceStatusNameListForFilter.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedServiceStatusListForFilter(temp);
			setServiceStatusNameListForFilter(tempSR);
			//getExternalPartnerServices(tableInstance);
		} 
		else
		{
			setSelectedServiceStatusListForFilter([]);
			//getExternalPartnerServices(tableInstance);
		}
	};

	const toggleSelectionForServiceStatusFilter = (e) => {
		setSelectedServiceStatusListForFilter(e);
	};


    const onTabChanged = async (selectedTab) => {
        setCurrentActiveTab(selectedTab);
	};

	const getUnreadFeedbackCount = () => {
        try
        {            
            const { data: _ignore_ } = api
                .getUnreadFeedbackCount()
                .then((d) => {
                    if (d.data) 
                    {
                        setunReadFeedbackCount(d.data.unread_feedbacks||0);                      
                    }
                })
                .catch((error) =>
                {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
        } 
        catch (error)
        {
        }            
    };

    const toggleColumnSelection = (e) => {
		let temp = ColumnDropdownList;
		let tempSrStatus = ColumnDropdownList.map((x) => {
            if (x.code == e) {
                x.checked = !x.checked;
            }
            return x;
        });
        setColumnDropdownList(tempSrStatus);
        storeSPMAdminColumns(tempSrStatus);
	};

    const selectSearchBySelection = (e) => {
		let temp = SearchByDropdownList;
		let tempserach = SearchByDropdownList.map((x) => {
            if (x.code == e) {
                x.checked = !x.checked;
            }
			else
			{
				x.checked = false;
			}
            return x;
        });
        setSearchByDropdownList(tempserach);
		isSearchClicked.current = true
	};

    return(
        <>
        {
            currentActiveTab==="Service Requests"?(
                <div className={`row ${isLoading && "set-opacity"}`}>
                    {isLoading && <Spinner className="center-screen" />}
                    {
                        <>
                            <SPMFilterSection
								toggleConfirmHandholderAssignmentModal={
									toggleConfirmHandholderAssignmentModal
								}
								onSelectFacilitator={setSelectedFacilitator}
								onAssignHandholder={handleFacilitatorAssigned}
								facilitatorList={facilitatorList}
								numberOfServices={numberOfServices}
								selectedServiceRequests={selectedServiceRequests}
								selectedFacilitator={selectedFacilitator}
								selectedServiceRequestsHasHandholder={
									selectedServiceRequestsHasFacilitator
								}

								toggleUnassignedServiceRequests={() => {
									if (!tableInstance) return;
			
									if (showFollowupInPast)
										toggleFollowupInPast(!showFollowupInPast);
			
									toggleUnassignedServiceRequests(
										!showUnassignedServiceRequests
									);
								}}
								showUnassignedServiceRequests={showUnassignedServiceRequests}

								onSearchInputChange={handleSearchInputChange}
								onSearchClicked={handleSearchClick}
								onClearFilterSearch={handleClearFilterSearch}
								searchTerm={searchTerm}

                                SearchByDropdownList={SearchByDropdownList}
                                isSearchByDropdownOpen={isSearchByDropdownOpen}
                                toggleSearchByVisibility={toggleSearchByVisibility}
                                SearchDropdownRef={SearchDropdownRef}
                                selectSearchBySelection={selectSearchBySelection}

                                packageNameListForFilter={packageNameListForFilter}
                                selectedPackageNameListForFilter={selectedPackageNameListForFilter}
                                toggleAllForPackageFilter={toggleAllForPackageFilter}
                                toggleSelectionForPackageFilter={toggleSelectionForPackageFilter}

                                toggleAllForServiceStatusFilter={toggleAllForServiceStatusFilter}
                                toggleSelectionForServiceStatusFilter={toggleSelectionForServiceStatusFilter}
                                selectedServiceStatusListForFilter={selectedServiceStatusListForFilter}
                                serviceStatusNameListForFilter={serviceStatusNameListForFilter}

                                showFeedbackButton={getUser()&&getUser().role.includes(1)}
                                unReadFeedbackCount={unReadFeedbackCount}
                                onTabChanged={onTabChanged}

								handleAssignFacilitatorUploadClick={handleAssignFacilitatorUploadClick}
                            />

                            <AdminServiceProgressionGrid
                                ColumnDropdownList={ColumnDropdownList}
                                data={serviceRequests}
                                selectedServiceRequests={selectedServiceRequests}
                                onSelectServiceRequest={setSelectedServiceRequests}
                                onFetchServiceRequests={fetchServiceRequests}
                                pages={pages}
                                pageSize={pageSize}
                                page={currentPage}
                                pageSizeOptions={pageSizeOptions}
                                selectedPageSizeOption={selectedPageSizeOption}
                                onPageSizeOptionChange={(option) => {
                                    setSelectedPageSizeOption(option);
                                }}
                                // For Column dropdown
                                toggleColumnVisibility={toggleColumnVisibility}
                                isColumnDropdownOpen={isColumnDropdownOpen}
                                toggleColumnSelection={toggleColumnSelection}
                                ColumnDropdownRef={ColumnDropdownRef}
                            />

							<ServiceRequestAssignmetSummaryModal
								numberOfServices={numberOfServices}
								bulkAssignServiceRequest={bulkAssignServiceRequest}
								isOpen={showConfirmHandholderAssignmentModal}
								toggleModal={toggleConfirmHandholderAssignmentModal}
								selectedServiceRequests={selectedServiceRequests}
								//selectedHandholder={selectedFacilitator}
								// handleHandholderAssigned={handleHandholderAssigned}
							/>
							
							<FacilitatorReassignmentModal
								isOpen={isAssignFacilitatorUploadOpen}
								toggleModal={handleAssignFacilitatorUploadClick}
								onAssignFacilitatorUpload={onAssignFacilitatorUpload}
								uploadAssignFacilitatorFile={uploadAssignFacilitatorFile}
								FileInputref={FileInputref}
							/>
                        </>
                    }
                </div>

            )
            :
            (
                <CustomerFeedbackContainer
                    onTabChanged={onTabChanged}
                    isForBusinessAdmin={true}
                />
            )
        }
            
        </>
);

}